import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=170017d4"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
import style0 from "./Player.vue?vue&type=style&index=0&id=170017d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports